// frontend/src/pages/MetaCubeOracleV3Page.jsx
import { useState, useRef, useEffect } from "react";
import MetaCubeOracleV3 from "../components/MetaCubeOracleV3";
import "../styles/metacube_oracle_v3.css";


export default function MetaCubeOracleV3Page() {
  // États entropie
  const [entropyUI, setEntropyUI] = useState(null);
  const [entropyDyn, setEntropyDyn] = useState(null);
  const [loadingUI, setLoadingUI] = useState(true);

  // États curseurs
  const [sphereSpeedPct, setSphereSpeedPct] = useState(80);
  const [waveSpeedPct, setWaveSpeedPct] = useState(60);
  const [eclipticSpeedPct, setEclipticSpeedPct] = useState(40); // <-- nouveau state

  // Options
  const [running, setRunning] = useState(true);
  const [chaos, setChaos] = useState(false);
  const [glow, setGlow] = useState(true);

  // Sliders Bloom
  const [bloomIntensity, setBloomIntensity] = useState(1.2);
  const [bloomRadius, setBloomRadius] = useState(0.6);
  const [bloomThreshold, setBloomThreshold] = useState(0.0);

  const containerRef = useRef(null);

  // ⚡ Score total
  const entropyTotal =
    entropyUI !== null && entropyDyn !== null
      ? (entropyUI + entropyDyn).toFixed(4)
      : "--";

  // --- Fetch entropie UI ---
  useEffect(() => {
    const fetchEntropyUI = async () => {
      try {
        setLoadingUI(true);
        const res = await fetch("/api/geometry/metacube_oracle_v3/entropy", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sphere_speed: sphereSpeedPct / 100,
            wave_speed: waveSpeedPct / 100,
            bloom_intensity: bloomIntensity,
            bloom_radius: bloomRadius,
            bloom_threshold: bloomThreshold,
            chaos,
            glow,
            running,
          }),
        });
        const data = await res.json();
        if (data.entropy !== undefined) {
          setEntropyUI(data.entropy);
        }
      } catch (err) {
        console.error("Erreur fetch entropy UI:", err);
        setEntropyUI(null);
      } finally {
        setLoadingUI(false);
      }
    };

    fetchEntropyUI();
  }, [
    sphereSpeedPct,
    waveSpeedPct,
    bloomIntensity,
    bloomRadius,
    bloomThreshold,
    chaos,
    glow,
    running,
  ]);

  return (
    <div className="page-container">
      <h1>MetaCube Oracle V3</h1>

      {/* Jauges */}
      <div className="gauges-row">
        <div className="card small">
          <h2>Entropie UI</h2>
          <div className="value ui">
            {loadingUI ? "⏳" : entropyUI !== null ? entropyUI.toFixed(4) : "❌"}
          </div>
        </div>
        <div className="card small">
          <h2 style={{ color: "#ff0266" }}>Entropie Dynamique</h2>
          <div className="value dyn">
            {entropyDyn !== null ? entropyDyn.toFixed(4) : "⏳"}
          </div>
        </div>
        <div className="card small">
          <h2 style={{ color: "#bb86fc" }}>Score Total</h2>
          <div className="value total">{entropyTotal}</div>
        </div>
      </div>

      {/* Contrôles + Visualizer */}
      <div className="controls-row">
        {/* Contrôles */}
        <div className="controls-panel">
          <button
            className="generate-button"
            onClick={() => setRunning((p) => !p)}
          >
            {running ? "⏸ Stop Animation" : "▶ Start Animation"}
          </button>

          <button
            onClick={() => setChaos((p) => !p)}
            className={chaos ? "toggle-button active-chaos" : "toggle-button inactive-chaos"}
          >
            {chaos ? "Désactiver Chaos" : "Activer Chaos"}
          </button>

          <button
            onClick={() => setGlow((p) => !p)}
            className={glow ? "toggle-button active-glow" : "toggle-button inactive-glow"}
          >
            {glow ? "Désactiver Glow" : "Activer Glow"}
          </button>

          {/* Sliders */}
          <div className="input-group">
            <label>Vitesse Sphère : {sphereSpeedPct}%</label>
            <input
              type="range"
              min={0}
              max={150}
              value={sphereSpeedPct}
              onChange={(e) => setSphereSpeedPct(Number(e.target.value))}
            />
          </div>

          <div className="input-group">
            <label>Vitesse Ondes : {waveSpeedPct}%</label>
            <input
              type="range"
              min={0}
              max={150}
              value={waveSpeedPct}
              onChange={(e) => setWaveSpeedPct(Number(e.target.value))}
            />
          </div>

          <div className="input-group">
            <label>Vitesse Écliptique : {eclipticSpeedPct}%</label>
            <input
              type="range"
              min={0}
              max={150}
              value={eclipticSpeedPct}
              onChange={(e) => setEclipticSpeedPct(Number(e.target.value))}
            />
          </div>

          {/* Sliders Bloom */}
<div className="input-group">
  <label>Halo Intensité : {bloomIntensity.toFixed(2)}</label>
  <input
    type="range"
    min={0}
    max={3}
    step={0.1}
    value={bloomIntensity}
    onChange={(e) => setBloomIntensity(Number(e.target.value))}
  />
</div>

<div className="input-group">
  <label>Halo Rayon : {bloomRadius.toFixed(2)}</label>
  <input
    type="range"
    min={0}
    max={2}
    step={0.1}
    value={bloomRadius}
    onChange={(e) => setBloomRadius(Number(e.target.value))}
  />
</div>

<div className="input-group">
  <label>Seuil Luminosité : {bloomThreshold.toFixed(2)}</label>
  <input
    type="range"
    min={0}
    max={1}
    step={0.01}
    value={bloomThreshold}
    onChange={(e) => setBloomThreshold(Number(e.target.value))}
  />
</div>

        </div>

        {/* Visualizer */}
        <div ref={containerRef} className="metacube-v3-canvas">
          <MetaCubeOracleV3
            containerRef={containerRef}
            running={running}
            chaos={chaos}
            glow={glow}
            sphereSpeedPct={sphereSpeedPct}
            waveSpeedPct={waveSpeedPct}
            eclipticSpeedPct={eclipticSpeedPct} // <-- nouvelle prop
            bloomIntensity={bloomIntensity}
            bloomRadius={bloomRadius}
            bloomThreshold={bloomThreshold}
            onEntropyUpdate={(val) => {
              if (val && typeof val.shannon === "number") {
                setEntropyDyn(val.accumulator);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
